import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { product1Image, product2Image, product3Image, product4Image, product5Image, product6Image } from '../../assets'
import { ProductComponent } from '../../SharedComponents'

export default function MoreProductsSection() {
    return (
        <div className='more-products-section'>
            <h3 style={{fontWeight:'800', marginBottom:'36px', textAlign:'start'}}>More Products</h3>
            <Row className='more-products mx-0' style={{ marginBottom: '153px' }}>
                <Col md={4}>
                    <ProductComponent title='Marine Plywood' image={product1Image} />
                </Col>
                <Col md={4} className='mt-5 pt-5 mt-md-0 pt-md-0'>
                    <ProductComponent title='Boiling Water Resistant Plywood' image={product2Image} />
                </Col>
                <Col md={4} className='mt-5 pt-5 mt-md-0 pt-md-0'>
                    <ProductComponent title='Moisture Resistant Plywood' image={product3Image} />
                </Col>
            </Row>
            <Row className='more-products mx-0'>
                <Col md={4}>
                    <ProductComponent title='Fire Retardant Plywood' image={product4Image} />
                </Col>
                <Col md={4} className='mt-5 pt-5 mt-md-0 pt-md-0'>
                    <ProductComponent title='Flushdoor' image={product5Image} />
                </Col>
                <Col md={4} className='mt-5 pt-5 mt-md-0 pt-md-0'>
                    <ProductComponent title='Flexyply' image={product6Image} />
                </Col>
            </Row>
        </div>
    )
}
